export default "__VITE_ASSET__473elxuf__"